import { render, staticRenderFns } from "./TopRatedMovie.vue?vue&type=template&id=051de2c4"
import script from "./TopRatedMovie.vue?vue&type=script&lang=js"
export * from "./TopRatedMovie.vue?vue&type=script&lang=js"
import style0 from "./TopRatedMovie.vue?vue&type=style&index=0&id=051de2c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports